import { QueryClient } from "@tanstack/react-query";

// Factory (không phải singleton module-level) — mỗi lần mount app tạo 1 client
// riêng qua useState initializer trong app/providers.tsx, tránh chia sẻ cache
// xuyên request khi Next.js tái dùng module trên server. App này client-only
// cho list (page.tsx không fetch list ở server) nên không cần hydration.
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // List đổi vừa phải; 30s đủ để dedup burst chuyển tab mà không cũ.
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        // App tự có SessionWatcher refetch on focus + WS live-update; KHÔNG
        // để React Query cũng refetch on focus (double fetch, nhảy scroll).
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}
